import { Navigate } from "react-router";

/** Canonical workspace home is `/workspace/{slug}`, not `/hub`. */
export function WorkspaceHubIndexRedirect() {
	return <Navigate to=".." replace />;
}
